export type InitialValues = {
    firstName: string;
    lastName: string;
    id: File[];
    proofOfIdentityChange: File[];
    registrationCertificate: File[];
    proofOfAddress: File[];
    email?: string;
};

export const initialValues: InitialValues = {
    firstName: '',
    lastName: '',
    id: [],
    proofOfIdentityChange: [],
    registrationCertificate: [],
    proofOfAddress: [],
};
